<app-item-content [instructionItemContentTemplate]="itemContentBoxes" [row]="row" [startLabel]="startLabel" [endLabel]="endLabel"></app-item-content>
<ng-template #itemContentBoxes let-instruction="instruction" let-overlaps="scheduledAndOverlapsSelectedDate">
	@if (overlaps) {
		<app-instruction-box>{{ instruction.rerPercentage }} %</app-instruction-box>
		<app-instruction-box>{{ instruction.diet }}</app-instruction-box>
	}
</ng-template>